module.exports = __webpack_public_path__ + "static/media/mushroom_mozza_mobile_hero_en.9e84bc85.jpg";